import { AdStatus } from '@/types';

export enum ErrorCodesEnum {
  ValidationError = 'VALIDATION_ERROR',
  UserBannedError = 'USER_BANNED_ERROR',
  NotFoundError = 'NOT_FOUND_ERROR',
  UnconfirmedPhoneError = 'UNCONFIRMED',
}

export type ErrorExtension = {
  code: ErrorCodesEnum;
};

export type MutationError = {
  message: string;
  code?: string;
  path?: string[];
  extensions?: ErrorExtension;
};

export type MutationResponse<Entity> = {
  entity: Entity;
  errors: MutationError[];
};

export enum AdKind {
  Bumped = 'BUMPED',
  Premium = 'PREMIUM',
  Vipped = 'VIPPED',
}

export type AssetUrl = {
  id: string;
  url: string;
};

export type ShopServicesFeatures = {
  hasLogo?: boolean;
};

export type ShopFeatures = {
  hasSelfOtherAds?: boolean;
  shopPageEnabled?: boolean;
  subscribeEnabled?: boolean;
  servicesFeatures?: ShopServicesFeatures;
};

export enum AdContactInfoEnum {
  Agency = 'AGENCY',
  Shop = 'SHOP',
  User = 'USER',
}

export enum AdLabelEnum {
  Agency = 'AGENCY',
  Retailer = 'RETAILER',
  Sme = 'SME',
}

export type AdFeatures = {
  adFeatures?: {
    hasLabel?: boolean;
    label?: AdLabelEnum | null;
    advertisingEnabled?: boolean;
    contactInfoType?: AdContactInfoEnum;
    hasSelfOtherAds?: boolean;
  };
  shopFeatures?: Pick<ShopFeatures, 'shopPageEnabled'>;
};

export type AdDetailsAdFeatures = {
  hasLabel?: boolean;
  label?: AdLabelEnum | null;
  advertisingEnabled?: boolean;
  contactInfoType?: AdContactInfoEnum;
  hasSelfOtherAds?: boolean;
};

export type AdDetailsFeatures = {
  adFeatures?: AdDetailsAdFeatures;
  shopFeatures?: Pick<ShopFeatures, 'shopPageEnabled' | 'subscribeEnabled'>;
};

export type Shop = {
  id: string;
  logo: AssetUrl | null;
  name: string;
  uri: string;
  workingDays: string;
  workingHours: string;
  useSchedule?: boolean;
  schedule?: Array<{
    dayOfWeek: string;
    openTime: string;
    closeTime: string;
    checked: boolean;
  }>;
  description: string;
  isFavorited?: boolean;
  features?: ShopFeatures;
  adsCount?: number;
  address?: string;
  longitude?: string;
  latitude?: string;
};

export type Ad = {
  id: string;
  kinds: AdKind[];
  photo: AssetUrl;
  desktopPhoto?: AssetUrl;
  isBookmarked: boolean;
  price: number | null;
  region: string;
  path: string;
  shop: Shop | null;
  features?: AdFeatures;
  title: string;
  updatedAt: string;
  legacyResourceId: number;
  status: AdStatus;
};

export type CreateCallResponse = {
  createCall: MutationResponse<string[]>;
};

export type CreateReportResponse = {
  createReport: MutationResponse<boolean>;
};

export enum PlatformSource {
  Mobile = 'MOBILE',
  App = 'APP',
  Desktop = 'DESKTOP',
}
